module.exports = __webpack_public_path__ + "static/media/04.cee19b43.mp3";